import { Component, OnInit, HostBinding, ViewChild, Injector, NgZone, AfterViewInit, ElementRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { UserPerformerEntity } from '../../entities/user-performer.entity';
import { PerformerConfigService } from '../../performer-config.service';
import { HttpService } from '@ecp-caf/caf-common';
import { MessagerService } from '@farris/ui-messager';
import { PersonnelSelectorComponent } from '@farris/ui-personnel-selector';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

declare var System: any;
@Component({
  selector: 'app-user-performer',
  templateUrl: './user-performer.component.html',
  styleUrls: ['./user-performer.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class UserPerformerComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'd-flex flex-fill h-100';

  @ViewChild(PersonnelSelectorComponent) userHelp: PersonnelSelectorComponent;

  @ViewChild('inputGroup') inputGroup: ElementRef;
  showClearButton = false;

  bindingData: { id?, name?} = {};
  farrisUserHelpShowTabIds = 'recent,organization';
  activeTabId = 'organization';
  selectedUserIds =  '';
  userTypeCollection = [
    { text: this.localePipe.transform('component.userPerformer.regularUser'), value: 'user' },
    { text: this.localePipe.transform('component.userPerformer.variablePart'), value: 'variable' }
  ];
  userType = this.userTypeCollection[0].value;
  variableOrgTypes = [
    { name: this.localePipe.transform('component.userPerformer.sys'), value: 'Sys' },
    { name: this.localePipe.transform('component.userPerformer.administrative_organization'), value: 'Administrative_organization' }
  ];
  curOrgType = this.variableOrgTypes[0].value;
  hasAdminOrg = false;
  userTypeButtonNeedShow = false; // 用户类型单选按钮是否需要显示
  multiSelect = true; //选人组件是否支持多选（编辑用户时只能单选）
  condition: string;
  users: UserPerformerEntity[] = [];
  constructor(
    private designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private injector: Injector,
    private lookupConfig: PerformerConfigService,
    private ngZone: NgZone,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    private http?: HttpService,
    private message?: MessagerService
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    const url = '/api/runtime/wf/v1.0/reportingOrgType/hasAdminOrg';
    this.http.get(url).subscribe((data: any) => {
      this.hasAdminOrg = data;
      // inSuite场景，变量参与者场景下显示用户类型
      if (this.designerUIState.scene === 'inSuite' && this.userType === 'variable') {
        this.userTypeButtonNeedShow = true;
      } else {
        this.userTypeButtonNeedShow = data && (this.userType === 'variable' || this.userType === null);
      }
    });
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }

  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }
  clear(data: any) {
    this.bindingData = {};
    this.users = [];
    this.selectedUserIds = '';
    this.variableOrgTypes = [
      { name: this.localePipe.transform('component.userPerformer.sys'), value: 'Sys' },
      { name: this.localePipe.transform('component.userPerformer.administrative_organization'), value: 'Administrative_organization' }
    ];
  }
  selectUsers(data: any) {
    // 固定用户
    if (this.userType === this.userTypeCollection[0].value) {
      this.lookupConfig.getLookupConfig().subscribe(re => {
        // 项目配置了自己的帮助时
        if (re.user && re.user.impl) {
          System.import(re.user.impl)
            .then((moduleFactorys: any) => {
              const moduleFactory: any = Object.values(moduleFactorys)[0];
              const moduleRef = moduleFactory.create(this.injector);
              moduleRef.instance.showHelp().subscribe(data => {
                if (data && data.length > 0) {
                  this.users = data.map(u => {
                    const user = new UserPerformerEntity(u.id, u.name, 'wf.UserParticipantExpression');
                    user.orgId = u.orgId;
                    user.orgName = u.orgName;
                    user.userType = this.userTypeCollection[0].value;
                    return user;
                  });
                }
              });
            });
        } else { // 加载默认帮助
          this.userHelp.farrisDialogshow();
        }
      });
    } else {
      this.showExprHelp();
    }
  }
  editConditon() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.condition);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.condition = expressioninfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  usersSelect(event: any) {
    this.users = event.data.map(u => {
      const user = new UserPerformerEntity(u.userId, u.name, 'wf.UserParticipantExpression');
      user.orgId = u.defaultOrgId;
      user.performerCode = u.code;
      user.orgName = u.orgAllPath;
      user.userType = this.userTypeCollection[0].value;

      return user;
    });
  }
  showExprHelp() {
    // this.expr.clearContext();
    this.expr.setEditPattern(ExprEditMode.Advanced);
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    const context = new Array();
    if (this.designerUIState.participantContext.length > 0) {
      for (const variable of this.designerUIState.participantContext) {
        context.push(variable);
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    if (this.users.length > 0) {
      this.expr.addExpressionText(this.users[0].performerId);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressioninfo: string) => {
      const user = new UserPerformerEntity(expressioninfo, '', 'wf.UserParticipantExpression');
      user.tag = 'expression';
      user.performerName = this.variableParticipantName(expressioninfo);
      user.userType = this.userTypeCollection[1].value;
      if (this.variableParticipantName(expressioninfo) === '') {
        this.message.error(this.localePipe.transform('component.userPerformer.cantUseContext'));
        this.users = [];
      } else {
        this.users = [user];
      }
      for (const c of this.designerUIState.participantContext) { // 根据表达式中的函数名判断是否使用的是上下文变量,除三种特殊上下文变量其余放开限制
        if (user.performerId.indexOf(c.key) >= 0) {
          this.variableOrgTypes = [
            { name: this.localePipe.transform('component.userPerformer.sys'), value: 'Sys' }];
          break;
        } else {
          this.variableOrgTypes = [
            { name: this.localePipe.transform('component.userPerformer.sys'), value: 'Sys' },
            { name: this.localePipe.transform('component.userPerformer.administrative_organization'), value: 'Administrative_organization' }
          ];
        }
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  getPerformers() {
    this.users.map(user => {
      if (user.orgId === undefined) {
        user.orgType = this.curOrgType;
        return user;
      }
    });
    if (!this.condition) {
      this.condition = '';
    }
    if (this.condition || this.condition === '') {
      this.users = this.users.map(user => {
        user.condition = this.condition;
        return user;
      });
    }
    return this.users;
  }
  private variableParticipantName(expr: string): string {
    for (const c of this.designerUIState.participantContext) {
      if (expr.indexOf(c.key) > -1) {
        if (this.curOrgType !== 'Sys') { // 行政人员类型不允许使用上下文变量
          return '';
        }
        return c.name;
      }
    }
    for (const c of this.designerUIState.processVariableContext) {
      if (expr.indexOf(c.key) > -1) {
        return c.name;
      }
    }
    return JSON.parse(expr).expr;
  }
  orgTypeChange(data: any) {
    if (data === 'Sys') {
      this.curOrgType = this.variableOrgTypes[0].value;
    } else {
        this.curOrgType = this.variableOrgTypes[1].value;
    }
  }
}
